var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.138 14.243a.2.2 0 01-.276 0l-6.69-6.398a.2.2 0 01.139-.345h13.378a.2.2 0 01.138.345l-6.689 6.398z",
    fill: "#959CAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 1.45c0-.11.09-.2.2-.2h5.85c.11 0 .2.09.2.2V7.5h-6.25V1.45zM3.125 16.5a.25.25 0 01.25-.25h13.25a.25.25 0 01.25.25v1.375a.25.25 0 01-.25.25H3.375a.25.25 0 01-.25-.25V16.5z",
    fill: "#959CAB"
  })));
}
export default __webpack_public_path__ + "static/menu-download.430c34f3.svg";
export { SvgMenuDownload as ReactComponent };